import service from "./service"

const backgroundCheckForm = async (key, referenceNumber) => {
    return service(key, referenceNumber)
}

export default backgroundCheckForm
